export enum SortType {
  NATURAL = 'Natural',
  INCREASE = 'Increase',
  DECREASE = 'Decrease',
}
